import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IWarehouseCirculationGetAllParams } from "@api/stores/warehouseCirculation/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  IWarehouseCirculationGetAllParams
>("stores.warehouseCirculations.exportPDF");

export const exportPDF = {
  ...getApis,
};
